<template>
    <div class="timelines">
        <div v-for="event in timeLineNodes" :key="event.id">
            <div class="flex-row justify-between" v-if="event.occur_event">
                <div class="flex-col">
                    <div class="image-text_1 flex-row justify-between">
                        <img class="icon_3" referrerpolicy="no-referrer" src="static/img/mobile/mobile_chevron-down2.svg" />
                        <span class="text-group_1" style="font-weight: bold">{{ event.dic_event_name }}</span>
                    </div>
                    <div class="box_3 flex-row">
                        <div class="group_6 flex-col"></div>
                        <span class="text_5" @click="changeOccrTime(event)">{{ $moment(event.occur_event.occur_time).format(`YYYY/MM/DD HH:mm`) }} &nbsp;{{ event.occur_event.modifier }}</span>
                    </div>
                </div>
                <div class="flex-col">
                    <span class="text_6">已确认</span>
                    <div class="button_confirm" v-if="event.occur_event.modifier == currentUser.dic_worker_name && IsHavePermission(`timeLine:cancel`)" @click="deleteOrrcutEvent(event.occur_event.id)">
                        取消
                    </div>
                </div>
            </div>
            <div class="flex-row justify-between" v-else-if="event.iscurrent_event">
                <div class="flex-col">
                    <div class="image-text_1 flex-row justify-between">
                        <div class="displayorder">
                            <span class="order_num">{{ event.display_order }}</span>
                        </div>
                        <span class="text-group_1" style="color: rgba(0, 150, 136, 1); font-weight: bold">{{ event.dic_event_name }}</span>
                    </div>
                    <div class="box_3 flex-row">
                        <div class="group_6 flex-col"></div>
                        <span class="text_5">暂无</span>
                    </div>
                </div>
                <div class="flex-col">
                    <div class="button_confirm" @click="confirm(event)" v-if="IsHavePermission(`timeLine:confirm`)" >确认</div>
                </div>
            </div>

            <div class="flex-row justify-between" v-else>
                <div class="flex-col">
                    <div class="image-text_1 flex-row justify-between">
                        <div class="displayorder" style="background-color: #f3f3f3">
                            <span class="order_num" style="color: rgba(153, 153, 153, 1)">{{ event.display_order }}</span>
                        </div>
                        <span class="text-group_1">{{ event.dic_event_name }}</span>
                    </div>
                    <div class="box_3 flex-row">
                        <div class="group_6 flex-col"></div>
                        <span class="text_5">暂无</span>
                    </div>
                </div>
                <div class="flex-col"><span class="text_6">未确认</span></div>
            </div>
        </div>
        <mt-popup v-model="eventChildDetail.popupVisible" position="bottom">
            <div class="box_7 flex-col" v-if="eventChildDetail.event && eventChildDetail.event.childrens">
                <div class="group_11 flex-col">
                    <span class="text_confirm">信息确认</span>
                    <div class="text-wrapper_confirm flex-row justify-between" v-for="checkContent in eventChildDetail.event.childrens" :key="checkContent.id">
                        <span class="text_confirm_detail" style="color: rgba(153, 153, 153, 1)">{{ checkContent.Name }}</span>
                        <span class="text_confirm_detail" style="color: rgba(51, 51, 51, 1)">{{ checkContent.check_value }}</span>
                    </div>

                    <div class="confirm_box_button flex-row justify-between">
                        <button class="button_2 flex-col" @click="eventChildDetail.popupVisible = false">
                            <span class="text_31">取消</span></button
                        ><button class="button_2 flex-col" @click="detailConfirm(surgeryId, eventChildDetail.event)">
                            <span class="text_31">确定</span>
                        </button>
                    </div>
                </div>
            </div>
        </mt-popup>
        <el-dialog :close-on-click-modal="false" :show-close="false" width="80%" class="table-h300" :destroy-on-close="true" :visible.sync="eventChildDetail.showSelectTimeVisible">
            <div class="margin10 margin-none-h align-left">
                <span class="align-left line-height30">确认时间：</span>
                <el-date-picker type="datetime" style="width:6rem;" v-model="eventChildDetail.selectTime"></el-date-picker>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="eventChildDetail.showSelectTimeVisible = false">取 消</el-button>
                <el-button type="primary" @click="selectTimeConfirm(surgeryId, eventChildDetail.event)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MessageBox, Popup } from 'mint-ui'
export default {
    name: `TimeLine`,
    props: {
        surgeryId: Number,
        surgeryInfo: Object,
        visible: { type: Boolean }
    },

    components: {
        'mt-popup': Popup
    },
    data() {
        return {
            timeLineNodes: [],
            eventChildDetail: {
                popupVisible: false,
                showSelectTimeVisible: false,
                selectTime: null,
                event: null,
                isUpdate: false
            },
            permissions: []
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `screenHeight`, `sysuser/workers`, `ward_auth`, `active_hospital_ward`]),
        IsHavePermission() {
            return permissionNo => {
                return _.find(this.permissions, { no: permissionNo }) != undefined
            }
        }
    },
    created() {
        if (this.surgeryId) {
            this.loadAllTimeLineNodes(this.surgeryId)
            this.loadPermissions()
        }
    },
    mounted() {},
    methods: {
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {
            })
        },
        loadAllTimeLineNodes(surgeryId) {
            let that = this
            that.timeLineNodes = []
            var getTimestamp = new Date().getTime()
            return new Promise((resolve, reject) => {
                let req = this.myaxios.mobile_get(`/api/AcisSystem/EventSetting/GetAllEvents?surgeryId=${surgeryId}&timestamp=${getTimestamp}`)
                req.then(data => {
                    that.timeLineNodes = data
                    resolve(data)
                })
            })
        },
        confirm(event) {
            let that = this
            if (event.childrens && event.childrens.length > 0) {
                _.forEach(event.childrens, c => {
                    c.check_value = that.surgeryInfo[c.Value]
                })
                this.eventChildDetail.popupVisible = true
                this.eventChildDetail.event = event
            } else {
                // 直接确认
                // this.saveOrrcutEvent(this.surgeryId, event)
                this.eventChildDetail.showSelectTimeVisible = true
                this.eventChildDetail.selectTime = new Date()
                this.eventChildDetail.event = event
            }
        },
        selectTimeConfirm(surgeryId, event) {
            this.eventChildDetail.showSelectTimeVisible = false
            this.saveOrrcutEvent(surgeryId, event).then(data => {
                this.eventChildDetail.popupVisible = false
                this.eventChildDetail.event = null
                this.eventChildDetail.selectTime = null
                this.eventChildDetail.isUpdate = false
            })
        },
        detailConfirm(surgeryId, event) {
            this.eventChildDetail.showSelectTimeVisible = true
            this.eventChildDetail.selectTime = new Date()
            this.eventChildDetail.event = event
        },
        saveOrrcutEvent(surgeryId, event) {
            let that = this
            return new Promise((resolve, reject) => {
                let time = that.$moment(that.eventChildDetail.selectTime).format(`yyyy-MM-DD HH:mm`)
                let data = {
                    id: (event.occur_event && event.occur_event.id) || 0,
                    remark: `移动护理`,
                    modifier: this.currentUser && this.currentUser.dic_worker_id,
                    dic_event_id: event.dic_event_id,
                    biz_surgery_info_id: surgeryId,
                    enum_record_type: 90,
                    occur_time: time
                }
                let req = null
                if (that.eventChildDetail.isUpdate) {
                    req = this.myaxios.put(`/api/Nursing/PatientTransport/Put`, data)
                } else {
                    req = this.myaxios.mobile_post(`/api/Nursing/PatientTransport/Post`, data)
                }
                req.then(data => {
                    that.loadAllTimeLineNodes(surgeryId)
                    resolve(data)
                })
            })
        },
        changeOccrTime(event) {
            this.eventChildDetail.showSelectTimeVisible = true
            this.eventChildDetail.event = event
            this.eventChildDetail.isUpdate = true
            this.eventChildDetail.selectTime = this.$moment(event.occur_event.occur_time).format(`YYYY/MM/DD HH:mm`)
        },
        deleteOrrcutEvent(id) {
            let that = this
            MessageBox.confirm(`此操作将永久删除该记录, 是否继续?`)
                .then(action => {
                    let req = this.myaxios.delete(`/api/Nursing/PatientTransport/DeleteNode/${id}`)
                    req.then(() => {
                        that.loadAllTimeLineNodes(this.surgeryId)
                    })
                })
                .catch(action => {})
        }
    },
    watch: {
        visible: function(newUrl, oldUrl) {
            if (this.visible) {
                this.loadAllTimeLineNodes(this.surgeryId)
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import './mobile_common.css';
.page {
    background-color: rgba(242, 242, 246, 1);
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    padding-bottom: 21px;
}
    .box_1 {
        background-color: rgba(241, 244, 246, 1);
        position: relative;
        height: 100%;
        margin: 0px auto;
        min-width: 334px;
        width: 100%;
    }

    .section_1 {
        background-color: rgba(255, 255, 255, 1);
        width: 100%;
        justify-content: flex-center;
        padding: 0.2rem 0.1rem 0.1rem 0.2rem;
    }

    .icon_1 {
        width: 0.64rem;
        height: 0.64rem;
        margin: 0.16rem 0 0.16rem 0;
    }

    .text_1 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.426rem;
        font-family: PingFangSC-Regular;
        font-weight: 500;
        text-align: right;
        white-space: nowrap;
        line-height: 0.587rem;
        margin: 0.187rem 0 0 0.107rem;
    }

    .input_1 {
        background-color: rgba(241, 244, 246, 1);
        border-radius: 20px;
        margin-left: 0.267rem;
        width: 60%;
        height: 0.85rem;
        padding: 0.05rem 0.187rem 0.2rem 0.22rem;
    }

    .el-input /deep/ .el-input__inner {
        height: 0.75rem;
        line-height: 0.75rem;
        background-color: #f1f4f6;
        border: none;
        font-size: 0.4rem;
        padding: 0px 4px 0px 15px;
    }

    .block_3 {
        margin: 0.054rem 0 0.027rem 0.4rem;
    }

    .icon_2 {
        width: 0.534rem;
        height: 0.534rem;
        margin: 0.027rem 0 0.027rem 0;
    }

    .text_2 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.426rem;
        font-family: PingFangSC-Regular;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 0.587rem;
        margin-left: 0.16rem;
    }

    .text_3 {
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 0.3rem;
        font-family: PingFangSC-Regular;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 13px;
        margin-left: -0.125rem;
    }

    .thumbnail_1 {
        width: 0.027rem;
        height: 0.534rem;
        margin: 0.027rem 0 0.027rem 0;
    }

    .section_2 {
        // padding-bottom: 0.827rem;
        flex: 1;
    }

    ::-webkit-scrollbar {
        height: 6px !important;
    }

    .tabs_1 {
        background-color: rgba(255, 255, 255, 1);
        padding: 0px 10px;
    }

    .text-wrapper_1 {
        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;
    }

    .text {
        overflow-wrap: break-word;
        font-size: 0.426rem;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        text-align: right;
        white-space: nowrap;
        line-height: 0.5rem;
        padding: 10px 0 !important;
    }

    .text-wrapper_1 /deep/ .mint-tab-item {
        flex: 0;
    }

    .text-wrapper_1 /deep/ .is-selected {
        border-bottom: none;
        color: rgb(0, 150, 136);
    }

    .text /deep/ .mint-tab-item-label {
        font-size: inherit;
    }

    .group_1 {
        margin: 0.187rem 5.014rem 0 0;
    }

    .box_2 {
        background-color: rgba(0, 150, 136, 1);
        width: 1.707rem;
        height: 0.054rem;
    }

    .text-wrapper_base {
        background-color: rgba(255, 255, 255, 1);
        width: 100%;
        padding: 0.427rem 0.427rem 0.427rem 0.427rem;
    }

    .text-wrapper_2 {
        margin-top: 0.267rem;
    }

    .text_base {
        overflow-wrap: break-word;
        font-size: 0.426rem;
        font-family: PingFangSC-Regular;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 0.427rem;

        .text_base_label {
            color: rgba(153, 153, 153, 1);
        }

        .text_base_value {
            color: rgba(51, 51, 51, 1);
        }
    }

    .box_4 {
        background-color: rgba(255, 255, 255, 1);
        padding: 0.64rem 2.8rem 9.12rem 2.854rem;
    }

    .image_2 {
        width: 3.947rem;
        height: 3.307rem;
    }

    .text-group_1 {
        overflow-wrap: break-word;
        color: rgba(153, 153, 153, 1);
        font-size: 0.373rem;
        font-family: PingFangSC-Regular;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 0.534rem;
        margin: 0 1.254rem 0 1.2rem;
    }

    .section_3 {
        background-color: rgba(255, 255, 255, 1);
        position: fixed;
        bottom: 30px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 80%;
        align-items: center;
    }

    .button_1 {
        background-image: linear-gradient(179deg, rgba(14, 209, 164, 1) 0, rgba(0, 150, 136, 1) 100%);
        border-radius: 4px;
        padding: 0.24rem 3.92rem 0.24rem 3.92rem;
        width: 100%;
    }

    .text_25 {
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 0.59rem;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        width: 100%;
        white-space: nowrap;
        line-height: 0.587rem;
    }

    .timelines {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        margin-top: 0.267rem;
        padding: 0.32rem 0.32rem 0.587rem 0.427rem;

        .image-text_1 {
            width: 2.8rem;
            margin-right: 1.894rem;
        }

        .icon_3 {
            width: 0.587rem;
            height: 0.587rem;
        }

        .displayorder {
            background-color: rgba(0, 150, 136, 1);
            border-radius: 50%;
            // padding: 0 0.187rem 0 0.16rem;
            line-height: 0.256rem;
            height: 0.62rem;
            width: 0.62rem;

            .order_num {
                overflow-wrap: break-word;
                color: rgba(255, 255, 255, 1);
                font-size: 0.373rem;
                font-family: PingFangSC-Regular;
                font-weight: 500;
                text-align: right;
                white-space: nowrap;
                line-height: 0.587rem;
            }
        }

        .button_confirm {
            background-image: linear-gradient(179deg, rgba(14, 209, 164, 1) 0, rgba(0, 150, 136, 1) 100%);
            border-radius: 5px;
            color: #ffffff;
            font-size: 0.5rem;
            padding: 0.1rem;
            margin: 2px 0px;
            min-width: 80px;
        }

        .text-group_1 {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.4rem;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 0.587rem;
            margin: 0 1.254rem 0 0.3rem;
        }

        .box_3 {
            width: 4.427rem;
            margin-left: 0.267rem;
        }

        .group_6 {
            background-color: rgba(0, 150, 136, 1);
            width: 0.027rem;
            height: 0.64rem;
            margin-top: 0.214rem;
        }

        .text_5 {
            overflow-wrap: break-word;
            color: rgba(153, 153, 153, 1);
            font-size: 0.32rem;
            font-family: PingFangSC-Regular;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 0.534rem;
            padding-left: 0.534rem;
        }

        .text_6 {
            overflow-wrap: break-word;
            font-size: 0.5rem;
            color: rgba(102, 102, 102, 1);
            /* color: rgba(102, 102, 102, 1);
        font-size: 0.4rem;
        font-family: PingFangSC-Regular;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 0.56rem;
        margin-top: 0.347rem; */
        }
    }

    .box_7 {
        background-color: rgba(0, 0, 0, 0.55);
        width: 100%;
        // height: 15.067rem;
        height: 100%;

        .group_11 {
            background-color: rgba(255, 255, 255, 1);
            border-radius: 12px 12px 0px 0px;
            padding-top: 0.427rem;
        }

        .text_confirm {
            overflow-wrap: break-word;
            color: rgba(0, 0, 0, 0.9);
            font-size: 0.48rem;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            text-align: right;
            white-space: nowrap;
            line-height: 0.694rem;
            align-self: center;
        }

        .text-wrapper_confirm {
            background-color: rgba(255, 255, 255, 1);
            width: 9.6rem;
            // margin-top: 0.4rem;
            padding: 0.427rem 0.2rem 0.427rem 0.25rem;
        }

        .text_confirm_detail {
            overflow-wrap: break-word;
            font-size: 0.426rem;
            font-family: PingFangSC-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 0.427rem;
        }

        .confirm_box_button {
            background-color: rgba(255, 255, 255, 1);
            width: 100%;
            margin-top: 0.027rem;
            padding: 0.24rem 0.427rem 0.24rem 0.427rem;
        }

        .button_2 {
            background-image: linear-gradient(179deg, rgba(14, 209, 164, 1) 0, rgba(0, 150, 136, 1) 100%);
            border-radius: 4px;
            padding: 0.24rem 1.627rem 0.24rem 1.627rem;
        }

        .text_31 {
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.426rem;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            text-align: right;
            white-space: nowrap;
            line-height: 0.587rem;
        }
    }

    /deep/.el-dialog__body {
        font-size: 0.5rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/TimeLine.vue